import { BaseViewModel } from "../../common/BaseViewModel";
import * as format from "../../common/FormatFunctions";
import { CloudService } from "../../common/CloudService/ClientLibsReference";
import * as ApiService from "../../common/CloudService/ApiService";
import { CrudlStatus } from "../../common/config/AppConstants";
import * as UIMap from "../../common/PrimeComponents";
import * as Storage from "../../common/config/Storage";
export class DeliveryViewModel extends BaseViewModel {
  showLoadingScreen = () => {
    this.updateState("loaded", false);
  };

  hideLoadingScreen = () => {
    this.updateState("loaded", true);
  };

  getOrders = async () => {
    let orderResponse = await this.getOrderListByCodeTag();
    if (format.isNotNull(orderResponse.orderResponseList)) {
      this.logger.info(orderResponse.orderResponseList);
      this.updateState("orderList", orderResponse.orderResponseList);
    } else {
      return {};
    }
  };

  getProducts = async () => {
    var productResponse = await this.getProductListByCodeTag();
    if (productResponse.errorCode === 0) {
      if (format.isNotNull(productResponse.productList)) {
        this.updateState("productList", productResponse.productList);
        this.logger.info(productResponse.productList);
      } else {
        //this.showEmpty("Product");
      }
    } else {
      // this.showError("Product", CrudlStatus.LIST);
    }
  };

  getDeliverys = async () => {
    //CRITICAL - ERROR + EMPTY MESSAGE
    var deliveryResponse = await this.getDeliveryListByCodeTag();
    if (
      format.isNotNull(deliveryResponse.errorCode) &&
      deliveryResponse.errorCode === 0
    ) {
      if (format.isNotNull(deliveryResponse.deliveryList)) {
        this.updateState("deliveryList", deliveryResponse.deliveryList);
        this.logger.info(deliveryResponse.deliveryList);
      } else {
        this.showEmpty("Delivery");
      }
    } else {
      this.showError("Delivery", CrudlStatus.LIST);
    }
  };
  getDeliverysReturned = async () => {
    //CRITICAL - ERROR + EMPTY MESSAGE
    var deliveryResponse = await this.getDeliveryListByCodeTag();
    if (
      format.isNotNull(deliveryResponse.errorCode) &&
      deliveryResponse.errorCode === 0
    ) {
      if (format.isNotNull(deliveryResponse.deliveryList)) {
        this.logger.info(deliveryResponse.deliveryList);
        return deliveryResponse.deliveryList;
      } else {
        this.showEmpty("Delivery");
      }
    } else {
      this.showError("Delivery", CrudlStatus.LIST);
    }
  };

  reloadDataAfterExecute = (
    deliverys,
    apiResponse,
    type,
    externalStateValues
  ) => {
    var updatedDeliveryList = [];
    if (type === CrudlStatus.CREATE) {
      updatedDeliveryList = this.reloadAfterCreate(
        deliverys,
        apiResponse,
        externalStateValues
      );
    }
    if (type === CrudlStatus.UPDATE) {
      updatedDeliveryList = this.reloadAfterUpdate(
        deliverys,
        apiResponse,
        externalStateValues
      );
    }
    if (type === CrudlStatus.DELETE) {
      updatedDeliveryList = this.reloadAfterDelete(
        deliverys,
        apiResponse,
        externalStateValues
      );
    }

    this.updateState("deliveryList", updatedDeliveryList);
  };

  reloadAfterCreate = (deliveryList, apiResponse, externalStateValues) => {
    if (deliveryList === undefined || deliveryList === null) {
      deliveryList = [];
    }
    var deliveryBean = externalStateValues.deliveryBean;
    deliveryBean.id = apiResponse.id;
    deliveryBean.lastUpdatedDateTime = apiResponse.lastUpdatedDateTime;

    deliveryList.push(deliveryBean);

    return deliveryList;
  };

  reloadAfterUpdate = (deliveryList, apiResponse, externalStateValues) => {
    var i = 0;
    deliveryList.forEach(e => {
      if (apiResponse.id === e.id) {
        deliveryList[i] = externalStateValues.deliveryBean;
        deliveryList[i].lastUpdatedDateTime = apiResponse.lastUpdatedDateTime;
      }
      i++;
    });

    return deliveryList;
  };

  reloadAfterDelete = (deliveryList, apiResponse, externalStateValues) => {
    var i = 0;
    deliveryList.forEach(e => {
      //DELETE
      if (apiResponse.id === e.id) {
        deliveryList.splice(i, 1);
      }
      i++;
    });

    return deliveryList;
  };
  executeCRUDLAction = async (crudlStatus, stateVariables) => {
    let deliveryRequest = stateVariables.deliveryBean;
    if (crudlStatus === CrudlStatus.CREATE) {
      return await this.createDelivery(deliveryRequest, stateVariables);
    }
    if (crudlStatus === CrudlStatus.UPDATE) {
      return await this.updateDelivery(deliveryRequest, stateVariables);
    }
    if (crudlStatus === CrudlStatus.DELETE) {
      return await this.deleteDelivery(deliveryRequest);
    }
  };

  createDelivery = async (deliveryRequest, stateVariables) => {
    deliveryRequest.codeTag = this.codeTag;
    deliveryRequest.userId = this.userId;

    deliveryRequest.deliveryItemList = this.getDeliveryItemRequestList(
      deliveryRequest.deliveryItemRequestList
    );
    delete deliveryRequest.deliveryItemResponseList;
    delete deliveryRequest.deliveryItemRequestList;

    let deliveryResponse = await ApiService.deliveryCreate(deliveryRequest);
    if (deliveryResponse.errorCode === 0) {
      this.showSuccess("Delivery", CrudlStatus.CREATE);
    } else {
      this.showError("Delivery", CrudlStatus.CREATE);
    }

    return deliveryResponse;
  };

  deleteDelivery = async deliveryRequest => {
    //RESET PRODUCT REQUEST
    var request = {};
    request.codeTag = this.codeTag;
    request.userId = this.userId;
    request.id = deliveryRequest.id;
    request.lastUpdatedDateTime = deliveryRequest.lastUpdatedDateTime;
    request.clientId = deliveryRequest.clientId;

    let deliveryResponse = await ApiService.deliveryDelete(request);
    if (deliveryResponse.errorCode === 0) {
      this.showSuccess("Delivery", CrudlStatus.DELETE);
    } else {
      this.showError("Delivery", CrudlStatus.DELETE);
    }

    return deliveryResponse;
  };

  updateDelivery = async (deliveryRequest, stateVariables) => {
    deliveryRequest.codeTag = this.codeTag;
    deliveryRequest.userId = this.userId;

    var deliveryItems = [];
    if (format.isNotNull(deliveryRequest.deliveryItemRequestList)) {
      deliveryItems = format.deepCopy(deliveryRequest.deliveryItemRequestList);
    }

    if (format.isNotNull(stateVariables.deletedDeliveryItemList)) {
      stateVariables.deletedDeliveryItemList.forEach(element => {
        if (format.isNotNull(element.id)) {
          var localElement = format.deepCopy(element);
          localElement.crudlStatus = CrudlStatus.DELETE.value;
          deliveryItems.push(localElement);
        }
      });
    }

    deliveryRequest.deliveryItemList = this.getDeliveryItemRequestList(
      deliveryItems
    );
    delete deliveryRequest.deliveryItemResponseList;
    delete deliveryRequest.deliveryItemRequestList;
    delete deliveryRequest.deliveryItemResponseList;

    this.logger.info(deliveryRequest);
    let deliveryResponse = await ApiService.deliveryUpdate(deliveryRequest);
    if (deliveryResponse.errorCode === 0) {
      this.showSuccess("Delivery", CrudlStatus.UPDATE);
    } else {
      this.showError("Delivery", CrudlStatus.UPDATE);
    }

    return deliveryResponse;
  };

  //CREATE AND UPDATE
  parseOrderItems = (orderItems, productList) => {
    if (format.isNotNull(orderItems)) {
      var parsedOrderItems = [];
      orderItems.forEach(bean => {
        var searchId = "";
        var quantity = "";
        var partProductJson = JSON.parse(bean.partProductJson);
        if (format.isNotNull(partProductJson)) {
          if (format.isNotNull(partProductJson.products)) {
            searchId = partProductJson.products[0].id;
            quantity = partProductJson.products[0].quantity;
          }
        }
        if (searchId !== "") {
          if (format.isNotNull(productList)) {
            productList.forEach(element => {
              if (element.id === searchId) {
                parsedOrderItems.push(
                  this.constructNewOrderItem(element, bean, quantity)
                );
              }
            });
          }
        }
      });

      return parsedOrderItems;
    }
  };

  //CREATE
  convertOrderToDelivery = (orderResponse, productList) => {
    var deliveryRequest = format.deepCopy(orderResponse);
    deliveryRequest.orderId = orderResponse.id;
    deliveryRequest.deliveryItemList = format.deepCopy(
      orderResponse.orderItemResponseList
    );

    delete deliveryRequest.orderItemResponseList;
    var deliveryItemRequestList = [];
    if (deliveryRequest.shipTogether === true) {
      if (format.isNotNull(deliveryRequest.deliveryItemList)) {
        deliveryRequest.deliveryItemList.forEach(bean => {
          var searchId = "";
          var quantity = "";
          var partProductJson = JSON.parse(bean.partProductJson);
          if (format.isNotNull(partProductJson)) {
            if (format.isNotNull(partProductJson.products)) {
              searchId = partProductJson.products[0].id;
              quantity = partProductJson.products[0].quantity;
            }
          }
          if (searchId !== "") {
            if (format.isNotNull(productList)) {
              productList.forEach(element => {
                if (element.id === searchId) {
                  deliveryItemRequestList.push(
                    this.constructNewDeliveryItem(element, bean, quantity, true)
                  );
                }
              });
            }
          }
        });
      }
    }
    deliveryRequest.deliveryItemRequestList = deliveryItemRequestList;
    return deliveryRequest;
  };

  // CREATE AND UPDATE
  constructNewOrderItem = (product, item, quantity, orderShipTogether) => {
    console.log(quantity);
    var orderItem = {};
    orderItem = item;

    orderItem.orderItemId = item.id;
    orderItem.quantity = quantity;
    orderItem.productName = product.name;
    orderItem.productDescription = product.shortDescription;
    orderItem.added = false;

    if (!item.quantityAdded) {
      if (item.shipTogether) {
        orderItem.quantityAdded = quantity;
      } else {
        orderItem.quantityAdded = 0;
      }
    } else {
      orderItem.quantityAdded = item.quantityAdded;
    }

    return orderItem;
  };

  //CREATE - ORDER SHIP TOGETHER TRUE
  constructNewDeliveryItem = (product, item, quantity, orderShipTogether) => {
    console.log(quantity);
    var deliveryItemRequest = {};
    deliveryItemRequest = item;

    deliveryItemRequest.orderItemId = item.orderItemId;
    deliveryItemRequest.quantity = quantity;
    deliveryItemRequest.productName = product.name;
    deliveryItemRequest.productDescription = product.shortDescription;
    deliveryItemRequest.added = false;
    deliveryItemRequest.crudlStatus = CrudlStatus.CREATE.value;
    if (orderShipTogether) {
      deliveryItemRequest.quantityAdded = quantity;
    } else {
      if (!item.quantityAdded) {
        if (item.shipTogether) {
          deliveryItemRequest.quantityAdded = quantity;
        } else {
          deliveryItemRequest.quantityAdded = 0;
        }
      } else {
        deliveryItemRequest.quantityAdded = item.quantityAdded;
      }
    }

    return deliveryItemRequest;
  };
  //UPDATE
  constructDeliveryItem = (product, item, quantity, orderItemTotalQuantity) => {
    console.log(quantity);
    var deliveryItemRequest = {};
    deliveryItemRequest = item;

    deliveryItemRequest.orderItemId = item.orderItemId;
    deliveryItemRequest.quantity = orderItemTotalQuantity;
    deliveryItemRequest.productName = product.name;
    deliveryItemRequest.productDescription = product.shortDescription;
    deliveryItemRequest.added = false;
    deliveryItemRequest.crudlStatus = CrudlStatus.UPDATE.value;

    deliveryItemRequest.quantityAdded = quantity;
    return deliveryItemRequest;
  };

  //UPDATE
  parseDeliveryAndItems = (deliveryResponse, productList, orderList) => {
    var orderItems = [];
    if (format.isNotNull(orderList)) {
      var orderAssociated = {};
      orderList.forEach(element => {
        if (element.id === deliveryResponse.orderId) {
          orderAssociated = element;
        }
      });
      if (format.isNotNull(orderAssociated)) {
        this.updateState("selectedOrder", orderAssociated);
        orderItems = this.parseOrderItems(
          format.deepCopy(orderAssociated.orderItemResponseList),
          productList
        );
        this.updateState("selectedOrderItems", orderItems);
      }
    }
    var deliveryRequest = deliveryResponse;
    deliveryRequest.deliveryItemRequestList = format.deepCopy(
      deliveryResponse.deliveryItemResponseList
    );

    delete deliveryRequest.deliveryItemResponseList;
    var deliveryItemRequestList = [];
    if (format.isNotNull(deliveryRequest.deliveryItemRequestList)) {
      deliveryRequest.deliveryItemRequestList.forEach(bean => {
        var orderItemAssociated = {};
        var orderItemTotalQuantity = "";
        if (format.isNotNull(orderItems)) {
          orderItems.forEach(element => {
            if (element.id === bean.orderItemId) {
              orderItemAssociated = element;
              var partProductJsonOrder = JSON.parse(element.partProductJson);
              if (format.isNotNull(partProductJsonOrder)) {
                if (format.isNotNull(partProductJsonOrder.products)) {
                  orderItemTotalQuantity =
                    partProductJsonOrder.products[0].quantity;
                }
              }
            }
          });
        }
        var searchId = "";
        var quantity = "";
        var partProductJson = JSON.parse(bean.partProductJson);
        if (format.isNotNull(partProductJson)) {
          if (format.isNotNull(partProductJson.products)) {
            searchId = partProductJson.products[0].id;
            quantity = partProductJson.products[0].quantity;
          }
        }
        if (searchId !== "") {
          if (format.isNotNull(productList)) {
            productList.forEach(element => {
              if (element.id === searchId) {
                deliveryItemRequestList.push(
                  this.constructDeliveryItem(
                    element,
                    bean,
                    quantity,
                    orderItemTotalQuantity
                  )
                );
              }
            });
          }
        }
      });
    }
    deliveryRequest.deliveryItemList = deliveryItemRequestList;
    return deliveryRequest;
  };

  //CREATE AND UPDATE
  getDeliveryItemRequestList = origDeliveryItemList => {
    var deliveryItemRequestList = [];
    var deliveryItemList = format.deepCopy(origDeliveryItemList);
    console.log(origDeliveryItemList);
    if (format.isNotNull(deliveryItemList)) {
      deliveryItemList.forEach(element => {
        console.log(element);
        var deliveryItem = this.parseDeliveryItemRequest(element);
        console.log(deliveryItem);
        if (format.isNotNull(deliveryItem)) {
          deliveryItemRequestList.push(deliveryItem);
        }
      });
    }

    return deliveryItemRequestList;
  };

  //CREATE AND UPDATE
  parseDeliveryItemRequest = origDeliveryItem => {
    console.log(origDeliveryItem);
    var deliveryItem = format.deepCopy(origDeliveryItem);

    if (format.isNotNull(deliveryItem)) {
      var partProductJson = JSON.parse(deliveryItem.partProductJson);
      if (format.isNotNull(partProductJson)) {
        if (format.isNotNull(partProductJson.products)) {
          if (deliveryItem.shipTogether === true) {
            console.log(deliveryItem.quantity);
            partProductJson.products[0].quantity = format.deepCopy(
              deliveryItem.quantity
            );
          } else {
            console.log(deliveryItem.quantityAdded);
            partProductJson.products[0].quantity = format.deepCopy(
              deliveryItem.quantityAdded
            );
          }
        }
        console.log(partProductJson);
        deliveryItem.partProductJson = JSON.stringify(partProductJson);
      }

      if (!deliveryItem.crudlStatus) {
        deliveryItem.crudlStatus = CrudlStatus.CREATE.value;
      }

      // delete deliveryItem.orderItemId;
      delete deliveryItem.productName;
      delete deliveryItem.productDescription;
      delete deliveryItem.quantity;
      delete deliveryItem.quantityAdded;
    }

    delete deliveryItem.added;
    return deliveryItem;
  };
}



// WEBPACK FOOTER //
// ./src/components/Deliverys/DeliveryViewModel.js